exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sgFloat-65bee5af{position:absolute;z-index:1;right:0;bottom:0;left:0;background:#FFF;box-shadow:0 0 15px rgba(0,0,0,0.15);min-width:100px;transition:height 200ms ease}.sgFloat-65bee5af .wrap-5f1360fa{padding:0 0;height:100%;display:flex;flex-direction:column}\n", ""]);

// Exports
exports.locals = {
	"sgFloat": "sgFloat-65bee5af",
	"wrap": "wrap-5f1360fa"
};